import memoize from 'memoize-one';

/**
 * Total unread chat messages across all room subscriptions.
 * Mirrors the header bell badge: muted rooms (disableNotifications) are skipped.
 */
export const getTotalUnreadCount = memoize(subscriptions =>
    (subscriptions || []).reduce((accum, subscription) => {
        if (!subscription || subscription.disableNotifications) return accum;
        return accum + (subscription.unread || 0);
    }, 0)
);
